export default "__VITE_ASSET__CaqvS4dX__"